import { useEffect, useState } from 'react';
import { useDashboard } from '../../../context/context/DashboardContext';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';
import styled from 'styled-components';

const MapWrapper = styled.div`
  width: 100%;
  max-width: 980px;
  height: 100%;
  margin: auto;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const geoUrl =
  'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson'; // Endereço para os dados geográficos

export function MonitoramentoMapa() {
  const [transformedData, setTranformedData] = useState<Record<string, number>>(
    {
      '': 0,
    },
  );
  const { dashboard } = useDashboard();
  const getColor = (value: number) => {
    if (value <= 10) return '#6FB1F4';
    if (value <= 50) return '#558ED8';
    if (value <= 100) return '#3181D1';
    if (value <= 300) return '#2D2DF4';
    if (value <= 1000) return '#000EC2';
    if (value <= 5000) return '#0010A4';
    if (value <= 10000) return '#000086';
    return '#03045E';
  };

  const stateCoords = {
    AC: [-70.543, -9.0238], // Acre
    AL: [-36.782, -9.5713], // Alagoas
    AP: [-51.9253, 0.902], // Amapá
    AM: [-63.8058, -3.3149], // Amazonas
    BA: [-41.7007, -12.5797], // Bahia
    CE: [-39.7241, -5.4984], // Ceará
    DF: [-47.9297, -15.7795], // Distrito Federal
    ES: [-40.3089, -19.1834], // Espírito Santo
    GO: [-49.2648, -15.9323], // Goiás
    MA: [-44.3028, -5.2086], // Maranhão
    MT: [-55.9239, -12.6413], // Mato Grosso
    MS: [-54.4795, -20.497], // Mato Grosso do Sul
    MG: [-44.3945, -18.5122], // Minas Gerais
    PA: [-52.003, -3.119], // Pará
    PB: [-36.9541, -7.1231], // Paraíba
    PR: [-51.2287, -25.2521], // Paraná
    PE: [-37.2667, -8.8137], // Pernambuco
    PI: [-42.6956, -7.7183], // Piauí
    RJ: [-43.2095, -22.9099], // Rio de Janeiro
    RN: [-36.9541, -5.4026], // Rio Grande do Norte
    RS: [-53.4914, -30.25], // Rio Grande do Sul
    RO: [-63.5806, -10.7835], // Rondônia
    RR: [-61.3012, 1.9386], // Roraima
    SC: [-49.3804, -27.2423], // Santa Catarina
    SP: [-46.6417, -23.5475], // São Paulo
    SE: [-37.4554, -10.682], // Sergipe
    TO: [-48.3336, -9.9441], // Tocantins
  };
  useEffect(() => {
    if (dashboard && dashboard.ufRegiao) {
      const transformedData = dashboard.ufRegiao.reduce((acc, atualState) => {
        // const code = codigosRegioes[atualState.regiao];
        if (atualState.quantidade > 0) {
          acc[atualState.uf] = atualState.quantidade;
        }
        return acc;
      }, {} as Record<string, number>);
      setTranformedData(transformedData);
    }
  }, [dashboard]);
  return (
    <MapWrapper>
      <ComposableMap
        projection="geoMercator"
        alignmentBaseline="central"
        projectionConfig={{ scale: 1000, center: [-52, -15] }}
        width={980}
        stroke="#ffff"
        height={800}
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const d = transformedData
                ? transformedData[geo.properties.sigla]
                : ''; // Mudamos para geo.id para pegar o código correto do estado
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={d ? getColor(d) : '#004386'}
                  style={{
                    hover: {
                      fill: '#0A78CB',
                    },
                  }}
                />
              );
            })
          }
        </Geographies>
        {Object.entries(stateCoords).map(([regionId, coordinates]) => (
          <Marker key={regionId} coordinates={coordinates as [number, number]}>
            <text
              textAnchor="middle"
              style={{ fontSize: '1rem', stroke: '#FFFF', fill: '#FFFF' }}
            >
              {regionId}
            </text>
          </Marker>
        ))}
      </ComposableMap>
    </MapWrapper>
  );
}
